import { csx } from '@vtex/admin-ui'
import React from 'react'

import type { ProducSkuImageDesktopProps_ProductSku$data } from '../ProducSkuImageDesktop/__generated__/ProducSkuImageDesktopProps_ProductSku.graphql'

export type ProductSkuImageGalleryImageProps = {
  activeSkuImage: ProducSkuImageDesktopProps_ProductSku$data['images']['edges'][number]['node']
}

export const ProductSkuImageGalleryImage = ({
  activeSkuImage,
}: ProductSkuImageGalleryImageProps) => (
  <div
    className={csx({
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    })}
  >
    <img
      src={activeSkuImage.urlFullSize}
      alt=""
      className={csx({
        maxHeight: '100%',
      })}
    />
  </div>
)
